import * as api from '../api/captureJanuary1Owners';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'PROCESS-MANAGER';

export const FETCH_CAPTURE_JANUARY1_OWNERS_RUNS = createRequestTypes(
  `${prefix}/FETCH_CAPTURE_JANUARY1_OWNERS_RUNS`,
);

export const fetchCaptureJanuary1OwnersRuns = makeApiActionCreatorV3(
  api.fetchCaptureJanuary1OwnersRuns,
  FETCH_CAPTURE_JANUARY1_OWNERS_RUNS[START],
  FETCH_CAPTURE_JANUARY1_OWNERS_RUNS[SUCCESS],
  FETCH_CAPTURE_JANUARY1_OWNERS_RUNS[ERROR],
);

export const FETCH_CAPTURE_JANUARY1_OWNERS_RUN = createRequestTypes(
  `${prefix}/FETCH_CAPTURE_JANUARY1_OWNERS_RUN`,
);

export const fetchCaptureJanuary1OwnersRun = makeApiActionCreatorV3(
  api.fetchCaptureJanuary1OwnersRun,
  FETCH_CAPTURE_JANUARY1_OWNERS_RUN[START],
  FETCH_CAPTURE_JANUARY1_OWNERS_RUN[SUCCESS],
  FETCH_CAPTURE_JANUARY1_OWNERS_RUN[ERROR],
);

export const ADD_CAPTURE_JANUARY1_OWNERS_RUN = createRequestTypes(
  `${prefix}/ADD_CAPTURE_JANUARY1_OWNERS_RUN`,
);

export const addCaptureJanuary1OwnersRun = makeApiActionCreatorV3(
  api.addCaptureJanuary1OwnersRun,
  ADD_CAPTURE_JANUARY1_OWNERS_RUN[START],
  ADD_CAPTURE_JANUARY1_OWNERS_RUN[SUCCESS],
  ADD_CAPTURE_JANUARY1_OWNERS_RUN[ERROR],
);
